import { keyframes } from "styled-components";

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const fadeUp = keyframes`
  from { opacity: 0; transform: translate3d(0, 1.5rem, 0); }
  to { opacity: 1; transform: none; }
`;

export const zoomOut = keyframes`
  from { transform: scale(1.12); }
  to { transform: scale(1); }
`;

export const bob = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(6px); }
`;

export const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

export const shimmer = keyframes`
  from { background-position: 150% 0; }
  to { background-position: -50% 0; }
`;
